"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommunityHouse__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        type: "constructor",
        inputs: [
            {
                name: "_propHouse",
                type: "address",
                internalType: "address",
            },
            {
                name: "_manager",
                type: "address",
                internalType: "address",
            },
            {
                name: "_creatorPassIssuer",
                type: "address",
                internalType: "address",
            },
        ],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "approve",
        inputs: [
            {
                name: "to",
                type: "address",
                internalType: "address",
            },
            {
                name: "tokenId",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "balanceOf",
        inputs: [
            {
                name: "owner",
                type: "address",
                internalType: "address",
            },
        ],
        outputs: [
            {
                name: "",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "contractURI",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "string",
                internalType: "string",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "createRound",
        inputs: [
            {
                name: "roundImpl",
                type: "address",
                internalType: "address",
            },
            {
                name: "roundTitle",
                type: "string",
                internalType: "string",
            },
            {
                name: "creator",
                type: "address",
                internalType: "address",
            },
        ],
        outputs: [
            {
                name: "round",
                type: "address",
                internalType: "address",
            },
        ],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "creatorPassIssuer",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "address",
                internalType: "contract ICreatorPassIssuer",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "exists",
        inputs: [
            {
                name: "tokenId",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        outputs: [
            {
                name: "",
                type: "bool",
                internalType: "bool",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "getApproved",
        inputs: [
            {
                name: "tokenId",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        outputs: [
            {
                name: "",
                type: "address",
                internalType: "address",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "id",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "initialize",
        inputs: [
            {
                name: "data",
                type: "bytes",
                internalType: "bytes",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "isApprovedForAll",
        inputs: [
            {
                name: "owner",
                type: "address",
                internalType: "address",
            },
            {
                name: "operator",
                type: "address",
                internalType: "address",
            },
        ],
        outputs: [
            {
                name: "",
                type: "bool",
                internalType: "bool",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "isRound",
        inputs: [
            {
                name: "round",
                type: "address",
                internalType: "address",
            },
        ],
        outputs: [
            {
                name: "",
                type: "bool",
                internalType: "bool",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "issueCreatorPassesTo",
        inputs: [
            {
                name: "creator",
                type: "address",
                internalType: "address",
            },
            {
                name: "amount",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "issueCreatorPassesToMany",
        inputs: [
            {
                name: "creators",
                type: "address[]",
                internalType: "address[]",
            },
            {
                name: "amounts",
                type: "uint256[]",
                internalType: "uint256[]",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "kind",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "bytes32",
                internalType: "bytes32",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "manager",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "address",
                internalType: "contract IManager",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "name",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "string",
                internalType: "string",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "ownerOf",
        inputs: [
            {
                name: "tokenId",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        outputs: [
            {
                name: "",
                type: "address",
                internalType: "address",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "propHouse",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "address",
                internalType: "contract IPropHouse",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "revokeCreatorPassesFrom",
        inputs: [
            {
                name: "creator",
                type: "address",
                internalType: "address",
            },
            {
                name: "amount",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "revokeCreatorPassesFromMany",
        inputs: [
            {
                name: "creators",
                type: "address[]",
                internalType: "address[]",
            },
            {
                name: "amounts",
                type: "uint256[]",
                internalType: "uint256[]",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "safeTransferFrom",
        inputs: [
            {
                name: "from",
                type: "address",
                internalType: "address",
            },
            {
                name: "to",
                type: "address",
                internalType: "address",
            },
            {
                name: "tokenId",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "safeTransferFrom",
        inputs: [
            {
                name: "from",
                type: "address",
                internalType: "address",
            },
            {
                name: "to",
                type: "address",
                internalType: "address",
            },
            {
                name: "tokenId",
                type: "uint256",
                internalType: "uint256",
            },
            {
                name: "data",
                type: "bytes",
                internalType: "bytes",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "setApprovalForAll",
        inputs: [
            {
                name: "operator",
                type: "address",
                internalType: "address",
            },
            {
                name: "approved",
                type: "bool",
                internalType: "bool",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "setContractURI",
        inputs: [
            {
                name: "_contractURI",
                type: "string",
                internalType: "string",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "supportsInterface",
        inputs: [
            {
                name: "interfaceId",
                type: "bytes4",
                internalType: "bytes4",
            },
        ],
        outputs: [
            {
                name: "",
                type: "bool",
                internalType: "bool",
            },
        ],
        stateMutability: "pure",
    },
    {
        type: "function",
        name: "symbol",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "string",
                internalType: "string",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "tokenURI",
        inputs: [
            {
                name: "tokenId",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        outputs: [
            {
                name: "",
                type: "string",
                internalType: "string",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "transferFrom",
        inputs: [
            {
                name: "from",
                type: "address",
                internalType: "address",
            },
            {
                name: "to",
                type: "address",
                internalType: "address",
            },
            {
                name: "tokenId",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "event",
        name: "Approval",
        inputs: [
            {
                name: "owner",
                type: "address",
                indexed: true,
                internalType: "address",
            },
            {
                name: "approved",
                type: "address",
                indexed: true,
                internalType: "address",
            },
            {
                name: "tokenId",
                type: "uint256",
                indexed: true,
                internalType: "uint256",
            },
        ],
        anonymous: false,
    },
    {
        type: "event",
        name: "ApprovalForAll",
        inputs: [
            {
                name: "owner",
                type: "address",
                indexed: true,
                internalType: "address",
            },
            {
                name: "operator",
                type: "address",
                indexed: true,
                internalType: "address",
            },
            {
                name: "approved",
                type: "bool",
                indexed: false,
                internalType: "bool",
            },
        ],
        anonymous: false,
    },
    {
        type: "event",
        name: "ContractURIUpdated",
        inputs: [
            {
                name: "uri",
                type: "string",
                indexed: false,
                internalType: "string",
            },
        ],
        anonymous: false,
    },
    {
        type: "event",
        name: "Transfer",
        inputs: [
            {
                name: "from",
                type: "address",
                indexed: true,
                internalType: "address",
            },
            {
                name: "to",
                type: "address",
                indexed: true,
                internalType: "address",
            },
            {
                name: "tokenId",
                type: "uint256",
                indexed: true,
                internalType: "uint256",
            },
        ],
        anonymous: false,
    },
    {
        type: "error",
        name: "ADDRESS_ZERO",
        inputs: [],
    },
    {
        type: "error",
        name: "ALREADY_MINTED",
        inputs: [],
    },
    {
        type: "error",
        name: "INVALID_APPROVAL",
        inputs: [],
    },
    {
        type: "error",
        name: "INVALID_OWNER",
        inputs: [],
    },
    {
        type: "error",
        name: "INVALID_RECIPIENT",
        inputs: [],
    },
    {
        type: "error",
        name: "LENGTH_GTE_32",
        inputs: [],
    },
    {
        type: "error",
        name: "NOT_MINTED",
        inputs: [],
    },
    {
        type: "error",
        name: "ONLY_HOUSE_OWNER",
        inputs: [],
    },
    {
        type: "error",
        name: "ONLY_PROP_HOUSE",
        inputs: [],
    },
    {
        type: "error",
        name: "VALUE_DOES_NOT_FIT_IN_8_BITS",
        inputs: [],
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class CommunityHouse__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(_propHouse, _manager, _creatorPassIssuer, overrides) {
        return super.deploy(_propHouse, _manager, _creatorPassIssuer, overrides || {});
    }
    getDeployTransaction(_propHouse, _manager, _creatorPassIssuer, overrides) {
        return super.getDeployTransaction(_propHouse, _manager, _creatorPassIssuer, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.CommunityHouse__factory = CommunityHouse__factory;
CommunityHouse__factory.bytecode = _bytecode;
CommunityHouse__factory.abi = _abi;
